import { render, staticRenderFns } from "./FamilyCarousel.vue?vue&type=template&id=5469d3c4"
import script from "./FamilyCarousel.vue?vue&type=script&lang=js"
export * from "./FamilyCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports